const FEATURES = {
  catalogFiltering: 'CatalogFiltering',
  catalogSearch: 'CatalogSearch',
  catalogPagination: 'CatalogPagination',
  connectChat: 'Connect',
  feedbackAnimation: 'FeedbackAnimation',
  feedbackOpensExternalLink: 'FeedbackOpensExternalLink',
  inPersonSupport: 'InPersonSupport',
  labEvaluation: 'LabEvaluation',
  budgetControl: 'BudgetControl',
  customCallouts: 'CustomCallouts',
};

export default FEATURES;
